import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {QueryStringUtils} from '../../utils/querystring.utils';
import {ListaPaginadaModel} from '@shared/models/lista-paginada.model';
import {MessagesService, NotificationType} from '@shared/services/message.service';
import { FileDownloadUtils } from '@shared/utils/file-download.utils';
import { ReportTypeEnum } from '@shared/enum/report-type.enum';

export abstract class CrudService<TResumo> {

  abstract baseUrl(): string;

  protected constructor(protected http: HttpClient, protected message: MessagesService) {}

  public list(filtro: any): Observable<ListaPaginadaModel<TResumo>> {
    const params = QueryStringUtils.buildQueryParams(filtro);
    return this.http.get<ListaPaginadaModel<TResumo>>(this.baseUrl(), {params: params});
  }

  public export(type: ReportTypeEnum, filtro: any, name: string): void {
    filtro.format = type.toString();
    const params = QueryStringUtils.buildQueryParams(filtro);
    this.http.get(this.baseUrl() + '/export', {responseType: 'arraybuffer', params: params}).subscribe(data => FileDownloadUtils.download(data, type, name));
  }

  public save<T>(entity: any, id?: number): Observable<T> {
    let url = this.baseUrl();
    if (id) {
      url += ('/' + id);
    }
    return this.http.post<T>(url, entity);
  }

  public delete<T>(id?: number): Observable<T> {
    let url = this.baseUrl();
    if (id) {
      url += ('/' + id);
    }
    return this.http.delete<T>(url);
  }

  public get<T>(id: number): Observable<T> {
    const url = this.baseUrl() + '/' + id;
    return this.http.get<T>(url);
  }

  public saveAndNotify<T>(entity: any, id?: number): Promise<T> {
    return new Promise((resolve) => {
      this.save<T>(entity, id).subscribe((n) => {
        if (id) {
          this.message.notifyI18n('general.messages.updated_record', NotificationType.Success);
        } else {
          this.message.notifyI18n('general.messages.inserted_record', NotificationType.Success);
        }
        resolve(n);
      });
    });
  }

  public confirmAndDelete(id: number) {
    return new Promise((resolve) => {
      this.message.confirmI18n('general.messages.cant_be_undone', 'general.messages.confirm_record_delete').then(() => {
        this.delete(id).subscribe(() => {
          this.message.notifyI18n('general.messages.deleted_record', NotificationType.Success);
          resolve(true);
        });
      });
    });
  }
}
